import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import './PageNotFound.css';

const PageNotFound = () => {
  const { t } = useLanguage();

  return (
    <div className="page-not-found">
      <h1>{t.notFound.title}</h1>
      <p>{t.notFound.message}</p>
      <Link to="/" className="btn">{t.notFound.goHome}</Link>
    </div>
  );
};

export default PageNotFound;
